import { FormControl } from '@angular/forms';

export class ConfirmPasswordValidator {
  static isValid(control: FormControl) {
    if (!control.parent) {
      return null;
    }

    const password = control.parent.get('password').value;
    const confirmPassword = control.value;

    // if return null
    // dont has error
    if (password === confirmPassword || !password) {
      return null;
    }

    // return error
    return { invalidConfirmPassword: true };
  }
}
